import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Table, Form, Select, Modal, message, Tooltip, Tag, Icon, Input, Radio, Row, Col, Switch, Badge } from 'antd';
import moment from 'moment';
import {
  constructColumnFilterCheckbox,
  constructColumnFilterRadio,
  constructColumnFilterSearch,
  constructColumn,
  handleOnAggregationTableChange
} from 'utils/table/table';
import { eInvoiceEnrollment, eInvoiceHPEnrollment } from 'utils/apis/eInvoice';
import { getHosts } from '../../../utils/apis/host';
import { StyledCard, StyledHeader } from '../eInvoice.styles';
import { withAppContext } from 'context/AppContext';
import { CSVLink } from 'react-csv';

const FormItem = Form.Item;
const { Option, OptGroup } = Select;

const RegisterEinvoiceUserForm = props => {
  const { getFieldDecorator, getFieldValue } = props.form;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('props', props);
    return () => {};
  }, []);

  const handleOnFormSubmit = e => {
    e.preventDefault();

    props.form.validateFields((err, values) => {
      console.log('err', err);
      console.log('values', values);

      if (!err) {
        Modal.confirm({
          title: 'Confirm Enrollment?',
          onOk() {
            setLoading(true);
            eInvoiceEnrollment(values).then(response => {
              console.log('response', response);

              if (response.status >= 200 && response.status < 300) {
                eInvoiceHPEnrollment(response.data).then(responseHP => {
                  console.log('responseHP', responseHP);

                  if (responseHP.status >= 200 && responseHP.status < 300) {
                    Modal.success({
                      title: 'Enrollment Successfully!',
                      //   content: 'Please check your email for the eInvoice HP Enrollment',
                      onOk() {
                        setLoading(false);
                        window.location.reload();
                      }
                    });
                  } else {
                    message.error(response.data || response.data.message);
                    setLoading(false);
                  }
                });
                // .catch(error => {
                //   message.error('Failed to eInvoiceHPEnrollment');
                //   setLoading(false);
                // });
              } else {
                message.error(response.data || response.data.message);
                setLoading(false);
              }
            });
            //   .catch(error => {
            //     message.error('Failed to Enrollment');
            //     setLoading(false);
            //   });
          }
        });
      }
    });
  };

  return (
    <div>
      <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: 24, textAlign: 'center' }}>Welcome to e-Invoice Enrollment</div>

      <div style={{ width: window.innerWidth < 1200 ? '100%' : 800, margin: '0 auto' }}>
        <Form
          hideRequiredMark
          layout="horizontal"
          labelCol={{ span: 7 }}
          wrapperCol={{ span: 15 }}
          //    onSubmit={handleOnFormSubmit}
        >
          <Form.Item label="Name">
            {getFieldDecorator('name', {
              rules: [{ required: true, message: 'Name is required' }]
            })(<Input disabled={loading} />)}
          </Form.Item>
          <Form.Item label="Email">
            {getFieldDecorator('email', {
              rules: [{ required: true, message: 'Email is required' }, { type: 'email', message: 'Please enter a valid email' }]
            })(<Input disabled={loading} />)}
          </Form.Item>
          <Form.Item label="Password">
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Password is required' }]
            })(<Input.Password disabled={loading} />)}
          </Form.Item>
          <Form.Item label="Contact No.">
            <Row gutter={8}>
              <Col span={8}>
                {getFieldDecorator('contact.countryCode', {
                  rules: [{ required: true, message: 'Contact No. is required' }]
                })(
                  <Select disabled={loading}>
                    <Option value="+60">+60</Option>
                    <Option value="+65">+65</Option>
                  </Select>
                )}
              </Col>
              <Col span={16}>
                {getFieldDecorator('contact.number', {
                  rules: [{ required: true, message: 'Contact No. is required' }]
                })(<Input disabled={loading} placeholder="123456789" />)}
              </Col>
            </Row>
          </Form.Item>

          <Form.Item wrapperCol={{ span: 16, offset: 7 }}>
            <Button
              key="submit"
              onClick={handleOnFormSubmit}
              type="primary"
              loading={loading}
              disabled={props.user.isAdmin || props.user.roles[0].permissions.includes(83) ? false : true}
              style={{ width: 160 }}
            >
              Enroll
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default withAppContext(Form.create()(RegisterEinvoiceUserForm));
